<template>
  <b-alert
    v-if="banner"
    show
    :variant="banner.variant"
    class="account-expiry-banner mb-1 py-1"
  >
    <div class="d-flex flex-wrap align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <span class="mr-50">⚠</span>
        <span>{{ banner.message }}</span>
      </div>
      <b-button
        size="sm"
        variant="outline-secondary"
        class="mt-50 mt-sm-0"
        @click="dismiss"
      >
        這次不顯示
      </b-button>
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BButton } from 'bootstrap-vue'
import { getSelfProfile } from '@/api/login'
import { getExpiryState } from '@/utils/accountExpiry'

// 「這次不顯示」只在本次登入（當前分頁工作階段）有效，重新登入後會再次提醒
const DISMISS_KEY = 'accountExpiryBannerDismissed'

export default {
  name: 'AccountExpiryBanner',
  components: {
    BAlert,
    BButton,
  },
  data() {
    return {
      expireDate: null,
      dismissedDate: sessionStorage.getItem(DISMISS_KEY),
    }
  },
  created() {
    // 先顯示登入時快取的到期日，再向後端取得最新資料
    this.expireDate = this.readCachedExpireDate()
    this.refreshExpireDate()
  },
  computed: {
    expiryState() {
      return getExpiryState(this.expireDate)
    },
    banner() {
      const state = this.expiryState
      // 沒有到期日、還沒進入提醒範圍，或使用者已選擇這次不顯示
      if (!state || this.dismissedDate === state.date) return null

      if (state.status === 'expired') {
        return {
          variant: 'danger',
          message: `當前賬號已於 ${state.date} 過期（已過期 ${Math.abs(state.daysLeft)} 天），請盡快續期。`,
        }
      }
      if (state.daysLeft === 0) {
        return {
          variant: 'warning',
          message: `當前賬號將於今天（${state.date}）到期，請盡快續期。`,
        }
      }
      return {
        variant: 'warning',
        message: `當前賬號還有 ${state.daysLeft} 天到期（${state.date}），請留意續期。`,
      }
    },
  },
  methods: {
    readCachedExpireDate() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}')
        return userData.expireDate || null
      } catch (e) {
        return null
      }
    },
    cacheExpireDate(expireDate) {
      try {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}')
        userData.expireDate = expireDate
        localStorage.setItem('userData', JSON.stringify(userData))
      } catch (e) {
        // 快取失敗不影響提醒顯示
      }
    },
    refreshExpireDate() {
      return getSelfProfile()
        .then((res) => {
          const expireDate = res && res.data ? res.data.expire_date : null
          if (expireDate) {
            this.expireDate = expireDate
            this.cacheExpireDate(expireDate)
          }
        })
        .catch(() => {
          // 取不到最新資料時沿用登入時的快取，避免打擾使用者
        })
    },
    dismiss() {
      const state = this.expiryState
      if (!state) return
      sessionStorage.setItem(DISMISS_KEY, state.date)
      this.dismissedDate = state.date
    },
  },
}
</script>
